import { AccessPortal, Icon, toast } from '@livable/saas-react-components';
import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';
import React from 'react';
import { useStore } from 'src/stores';
import { dateToFormat } from 'src/utils/date';
import useStyles from '../styles';
export default function StatusCell(_ref) {
  let params = _ref.params;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const handleClick = async () => {
    if (!(params.row.status === 'pending' && (params.row.email || params.row.newEmail) && !params.row.portalAccessDateOnly)) return;
    const reInviteUserResp = await store.account.reInviteUserAsync.run(params.row.accountId);
    if (reInviteUserResp && reInviteUserResp.isSuccessful) {
      toast('success', {
        body: ['Re-invitation successfully sent']
      });
    }
  };
  const renderStatus = status => {
    switch (status) {
      case 'clear':
        return /*#__PURE__*/React.createElement(AccessPortal, {
          tooltipText: t('No email')
        });
      case 'active':
        return /*#__PURE__*/React.createElement(AccessPortal, {
          tooltipText: t('residencies_page.has_access_to_rp'),
          type: "success"
        });
      case 'pendingDate':
        return /*#__PURE__*/React.createElement(AccessPortal, {
          tooltipText: t('residencies_page.invitation_will_be_sent', {
            date: dateToFormat(params.row.portalAccessDateOnly),
            interpolation: {
              escapeValue: false
            }
          })
        });
      case 'pending':
        return /*#__PURE__*/React.createElement(AccessPortal, {
          tooltipText: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
            type: "clock"
          }), t('residencies_page.pending_resident_portal', {
            date: dateToFormat(params.row.enrolled),
            interpolation: {
              escapeValue: false
            }
          })),
          type: "warning"
        });
      case 'error':
        return /*#__PURE__*/React.createElement(AccessPortal, {
          tooltipText: t('residencies_page.invite_expired'),
          type: "error"
        });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.cellLeftAlign, " ").concat(classes.accessWrapper, " cellContent")
  }, params.row.vacant ? /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "access-key"
    }),
    variant: "portal"
  }) : /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.statusInfo, " ").concat(classes.chipsWrapper),
    onClick: handleClick
  }, params.row.email || params.row.newEmail ? !!params.row.portalAccessDateOnly ? renderStatus('pendingDate') : renderStatus(params.row.status) : renderStatus('clear')));
}